import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ec993ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6ec993ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec993ba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/render/index.vue
// module id = 17
// module chunks = 1